export const validatePermission = (
  userPermissions: any,
  permission: string
) => {
  return userPermissions.find((p: any) => p.name === permission) ? true : false;
};
